export default __webpack_public_path__ + "static/media/tickets.53f21656.svg";